import React from "react";
import { Input } from "../../../tabin/components/input";
import * as yup from "yup";
import { useCart } from "../../../context/cart-context";

// Validates NZ and AU mobile numbers in local or international formats.
// If not an NZ/AU mobile, requires full international format ^\+[0-9]+$.
//
// Allowed formats (no spaces, hyphens, or parentheses — strip these before validation):
//   NZ:  021xxxxxxx, +6421xxxxxxx, 006421xxxxxxx  (02 followed by 7–9 digits)
//   AU:  04xxxxxxxx, +614xxxxxxxx, 00614xxxxxxxx  (04 followed by 7–9 digits)
//
// Does NOT allow landlines or mixed characters.
// Must match the entire string (from start ^ to end $).
// Example matches: 0210589379, +64210589379, 0064210589379, 0412345678, +61412345678, 0061412345678
const phoneRegExpNZ_AU = /^((?:0|\+64|0064)2\d{7,9}|(?:0|\+61|0061)4\d{7,9})$/;
const phoneRegExpIntl = /^\+[0-9]+$/;

const emailSchema = yup.string().email("Please enter a valid email address").required("Please enter an email address");
const firstNameSchema = yup.string().required("Please enter your name");
// const lastNameSchema = yup.string().required("Please enter your last name");
const phoneNumberSchema = yup
    .string()
    .required("Please enter a phone number in case we need to contact you regarding your order")
    .test("phone-format", "Please enter a valid phone number", (value) => {
        if (!value) return false;
        // Remove spaces, hyphens, parentheses, and invisible chars
        const s = value.replace(/[^\d+]/g, "");

        const looksNZ = /^(?:0|\+64|0064)2/.test(s);
        const looksAU = /^(?:0|\+61|0061)4/.test(s);

        return looksNZ || looksAU ? phoneRegExpNZ_AU.test(s) : phoneRegExpIntl.test(s);
    });

export const GuestInformation = () => {
    const { guestInformation, setGuestInformation, tableNumber } = useCart();

    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGuestInformation({ ...guestInformation, email: event.target.value.toLowerCase(), emailError: "" });
    };

    const onChangeFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGuestInformation({ ...guestInformation, firstName: event.target.value, firstNameError: "" });
    };

    const onChangePhoneNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGuestInformation({ ...guestInformation, phoneNumber: event.target.value, phoneNumberError: "" });
    };

    const title = (
        <div className="title mb-1 mt-3">
            <div className="h3">Customer Information</div>
            <div className="separator-2"></div>
        </div>
    );

    const onBlurEmail = async () => {
        try {
            await emailSchema.validate(guestInformation.email);
            setGuestInformation({ ...guestInformation, emailError: "" });
        } catch (e) {
            setGuestInformation({ ...guestInformation, emailError: e.errors[0] });
        }
    };

    const onBlurFirstName = async () => {
        try {
            await firstNameSchema.validate(guestInformation.firstName);
            setGuestInformation({ ...guestInformation, firstNameError: "" });
        } catch (e) {
            setGuestInformation({ ...guestInformation, firstNameError: e.errors[0] });
        }
    };

    const onBlurPhoneNumber = async () => {
        try {
            await phoneNumberSchema.validate(guestInformation.phoneNumber);
            setGuestInformation({ ...guestInformation, phoneNumberError: "" });
        } catch (e) {
            setGuestInformation({ ...guestInformation, phoneNumberError: e.errors[0] });
        }
    };

    const emailInput = (
        <>
            <Input
                name="email"
                // label="Email"
                placeholder="Email"
                type="text"
                onChange={onChangeEmail}
                onBlur={onBlurEmail}
                value={guestInformation.email}
                error={guestInformation.emailError}
            />
        </>
    );

    const firstNameInput = (
        <>
            <Input
                name="firstName"
                // label="First Name"
                placeholder="Name"
                type="text"
                onChange={onChangeFirstName}
                onBlur={onBlurFirstName}
                value={guestInformation.firstName}
                error={guestInformation.firstNameError}
            />
        </>
    );

    const phoneNumberInput = (
        <>
            <Input
                name="phoneNumber"
                // label="First Name"
                placeholder="Phone Number"
                type="tel"
                onChange={onChangePhoneNumber}
                onBlur={onBlurPhoneNumber}
                value={guestInformation.phoneNumber}
                error={guestInformation.phoneNumberError}
            />
        </>
    );

    return (
        <>
            <div>
                {title}
                {/* <Title2Font>Sign up</Title2Font> */}
                {/* <div className="mt-4"></div> */}
                {/* {serverError && <div className="text-error mb-3">{serverError}</div>} */}
                {!tableNumber && firstNameInput}
                <div className="mb-1"></div>
                {emailInput}
                <div className="mb-1"></div>
                {!tableNumber && phoneNumberInput}
            </div>
        </>
    );
};
